import React, { createContext, useState, useContext, useEffect } from 'react';
import { mockAlerts } from '../mock/mockData';

const AlertsContext = createContext();

export const AlertsProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);
  const [activeAlerts, setActiveAlerts] = useState([]);

  // Initialize with mock data
  useEffect(() => {
    setAlerts(mockAlerts);
    updateActiveAlerts(mockAlerts);
  }, []);

  // Filter active alerts
  const updateActiveAlerts = (allAlerts) => {
    const active = allAlerts.filter(alert => alert.status === 'active');
    setActiveAlerts(active);
  };

  // Add a new alert
  const addAlert = (newAlert) => {
    const updatedAlerts = [...alerts, newAlert];
    setAlerts(updatedAlerts);
    updateActiveAlerts(updatedAlerts);
  };

  // Update alert status
  const updateAlertStatus = (alertId, newStatus) => {
    const updatedAlerts = alerts.map(alert => 
      alert.id === alertId ? { ...alert, status: newStatus } : alert
    );
    setAlerts(updatedAlerts);
    updateActiveAlerts(updatedAlerts);
  };

  // Clear resolved alerts (for demo purposes)
  const clearResolvedAlerts = () => {
    const updatedAlerts = alerts.filter(alert => alert.status === 'active');
    setAlerts(updatedAlerts);
    setActiveAlerts(updatedAlerts);
  };
  
  // Get alerts for a specific user
  const getUserAlerts = (userId) => {
    return alerts.filter(alert => alert.userId === userId);
  };
  
  // Acknowledge an alert (for client side)
  const acknowledgeAlert = (alertId) => {
    const updatedAlerts = alerts.map(alert => 
      alert.id === alertId ? { 
        ...alert, 
        status: 'acknowledged',
        acknowledgedAt: new Date().toISOString() 
      } : alert
    );
    setAlerts(updatedAlerts);
    updateActiveAlerts(updatedAlerts);
    return updatedAlerts.find(alert => alert.id === alertId);
  };
  
  // Resolve an alert (for admin side)
  const resolveAlert = (alertId, resolutionNote = '') => {
    const updatedAlerts = alerts.map(alert => 
      alert.id === alertId ? { 
        ...alert, 
        status: 'resolved',
        resolvedAt: new Date().toISOString(),
        resolutionNote 
      } : alert
    );
    setAlerts(updatedAlerts);
    updateActiveAlerts(updatedAlerts);
    return updatedAlerts.find(alert => alert.id === alertId);
  };

  return (
    <AlertsContext.Provider value={{ 
      alerts, 
      activeAlerts, 
      addAlert, 
      updateAlertStatus, 
      clearResolvedAlerts,
      getUserAlerts,
      acknowledgeAlert,
      resolveAlert
    }}>
      {children}
    </AlertsContext.Provider>
  );
};

export const useAlerts = () => useContext(AlertsContext);

export default AlertsContext;
